import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('FarcanaDailyBonus').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },

  lockerWrapper: {
    width: '100%',
    zIndex: 5,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,

    transition: 'transform 0.2s ease-in-out',
  },

  backdrop: {
    width: '100vw',
    height: '100vh',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  bgWrapper: {
    position: 'relative',
    width: '100%',
    height: '128px',
    display: 'flex',
    overflow: 'hidden',

    justifyContent: 'center',
  },

  background: {
    position: 'absolute',
    top: '-30%',
    // maxWidth: '350px',
    width: '120%',
    zIndex: 0,
    filter: 'brightness(75%)',
  },

  textWrapper: {
    position: 'absolute',
    zIndex: 3,
    display: 'flex',
    flexDirection: 'column',
    top: '30%',
    width: '100%',
  },

  hardwareWrapper: {
    padding: '24px 16px',
    height: '197px',
  },

  heading: {
    margin: '0',
    fontWeight: 450,
    fontSize: '24px',
    lineHeight: '28px',
    textAlign: 'center',
    color: theme.colors.text.primary,
  },

  subHeading: {
    margin: '0',
    zIndex: 2,
    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '17px',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  rewardsTextWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 10vw',
    alignItems: 'center',
    height: '84px',
  },

  rewardTextAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  rewardsText: {
    fontSize: '18px',
    lineHeight: '18px',
    textAlign: 'center',
    color: theme.colors.text.primary,
    fontWeight: 450,
  },

  timeDisplayWrapper: {
    position: 'absolute',
    zIndex: 5,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    top: '92px',
  },

  nextUnlockText: {
    fontSize: '13px',
    color: theme.colors.text.secondary,
    fontWeight: 350,
    textAlign: 'center',
  },
}))
